import React, { useState } from 'react';
import RuleAdherenceChart from './RuleAdherenceChart';
import RuleImpactList from './RuleImpactList';

const RulePerformanceWidget = ({ adherenceData = [], impactData = [], adherenceLoading, impactLoading }) => {
  const [view, setView] = useState('chart');

  return (
    <div>
      {/* Toggle header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          Rule Performance
        </span>
        <div className="flex items-center gap-1 bg-muted rounded-md p-0.5">
          <button
            onClick={() => setView('chart')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'chart'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Adherence Chart
          </button>
          <button
            onClick={() => setView('list')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'list'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Impact List
          </button>
        </div>
      </div>

      {view === 'chart' && (
        <RuleAdherenceChart data={adherenceData} loading={adherenceLoading} />
      )}
      {view === 'list' && (
        <RuleImpactList data={impactData} loading={impactLoading} />
      )}
    </div>
  );
};

export default RulePerformanceWidget;
